<template>
  <div class="robot-nav-wrapper">
    <component :is="type" :nav-data="robotNav" @click="handleCLick" @hook:mounted="onLoad"></component>
    <span :class="[isMobile ? 'robot-nav-err' : 'robot-nav-err-pc']" v-if="html" v-html="html"></span>
  </div>
</template>

<script>
import MixinHandleAction from '@/components/MixinHandleActions.js';
import { IMSDK, SDKUtils } from '@/imsdk/index.ts';
import axios from 'axios';
import component from './RobotNavTemplate/require-all-robot-nav';
import globalWin from '@/utils/globalWin';
import { xml2json } from 'xml-js';

/**
 * @component 机器人导航
 */
export default {
  name: 'robot-nav',
  mixins: [MixinHandleAction],
  inject: ['OBJTYPES', 'to', 'globalData'],
  components: {
    ...component,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    type() {
      // 0，按钮型 1，简单文本型 2，基础型 3，多主题型 4，小卡片型 5，组合型 6，多级基础型
      let compontentType;
      switch (this.robotNav.navType) {
        case 0:
          compontentType = 'btnType';
          break;
        case 1:
          compontentType = 'SimpleTextType';
          break;
        case 2:
          compontentType = 'BasicType';
          break;
        case 3:
          compontentType = 'MultiThemeType';
          break;
        case 4:
          compontentType = 'LittleCardType';
          break;
        case 5:
          compontentType = 'CombinedType';
          break;
        case 6:
          compontentType = 'MultiBasicType';
          break;
      }
      return compontentType;
    },
    isMobile() {
      return !this.$platform.pc;
    },
  },
  data() {
    return {
      // 存储导航菜单数据。
      robotNav: {},
      html: '',
      // 存储全量的导航数据
      navData: {},
    };
  },
  async mounted() {
    if (this.data.content) {
      const jsonData = this.parseJsonFromXML(this.data.content);
      this.navData = jsonData;
      this.robotNav = jsonData.content.menu;
      return;
    }
    if (!this.data.path) {
      return;
    }

    const resPath = await SDKUtils.getDownloadUrl(this.data, IMSDK.OBJTYPES.OBJ_LONGTEXT);
    if (resPath) {
      axios
        .get(resPath)
        .then((response) => {
          if (response.status === 200) {
            const jsonData = this.parseJsonFromXML(response.data);
            this.navData = jsonData;
            this.robotNav = jsonData.content.menu;
          } else {
            this.html = '[获取消息内容异常]';
          }
        })
        .catch(() => {
          this.html = '[获取消息内容异常]';
        });
    } else {
      this.html = '[获取消息内容异常]';
    }
  },
  methods: {
    /**
     * @desc 点击事件拦截
     * @param {object} info - 模型信息
     */
    handleCLick(info, extData) {
      const reportData = Object.assign(
        // 基本信息
        {
          robot_nav_first_menu_id: info.id,
          robot_nav_first_menu_name: info.name || '',
          robot_nav_action_type: info.action || '',
        },
        // 通用扩展信息
        {
          robot_nav_id: this.navData.id || 0,
          robot_nav_name: this.navData.name || '',
        },
        // 其他扩展信息
        extData,
      );
      this.qidianDAReport(reportData);

      // 只有info中含有具体信息时，才触发消息发送
      if (Object.keys(info).length > 0) {
        const robotId = this.data.crm && this.data.crm.msg_webim_extra_data
        && this.data.crm.msg_webim_extra_data.uint64_robotid;
        this.handleAction(info, '', robotId);
      }
    },

    // SDK中，机器人导航的数据是xml的，但是web端需要用到的格式是在xml附带的json中的<msg extraData='$json'>。
    parseJsonFromXML(data) {
      if (typeof (data) === 'string' && data.indexOf('<') === 0 && data.indexOf('extraData') > -1) {
        const jsonStr = xml2json(data, {
          compact: true,
          ignoreDeclaration: true,
        });

        let extraData = {};
        try {
          const jsonData = JSON.parse(jsonStr);
          // eslint-disable-next-line no-underscore-dangle
          const extStr = jsonData.msg._attributes.extraData;
          extraData = JSON.parse(extStr);

          console.log('extraData', extraData);
        } catch (ex) {
          console.error(ex);
        }

        return extraData;
      }
      if (typeof (data) === 'string') {
        try {
          return JSON.parse(data);
        } catch (ex) {}
      }
      return data;
    },

    /**
     * 营销上报
     */
    qidianDAReport(reportObj) {
      if (globalWin.robotTestMode) {
        return;
      }
      const reportMsg = Object.assign({
        robot_nav_conv_type: 4,
        robot_nav_cid: this.to.user_id,
        robot_nav_msg_dir: 2,
        robot_nav_event_type: 2,
        robot_nav_robot_id: Number(this.globalData.reception.robotId || 0),
        wpa_id: this?.wpaDetail?.wpaId ? Number(this.wpaDetail.wpaId) : '',
      }, reportObj);

      console.log('reportMsg', reportMsg);
      window.qidianDA('track', 'robot_nav_click', reportMsg);
    },

    /**
     * load
     */
    onLoad() {
      // 机器人导航的滚动比较特殊
      if (this.data.fromHisotry && !globalWin.isMsgFirstGet) {
        // 如果是历史中拉取的，就不需要动画效果。
        // 但是首次redering中，也是直接滚动到底部。
        globalWin.checkIfNeedScrollToBottom(true);
      } else {
        // 如果是实时推送的机器人导航，因为机器人导航会在开始级下发，，则直接滚动到底。
        globalWin.scrollToBottom();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.robot-nav-wrapper {
  border-radius: 6px;
  padding-bottom: 16px;
}
.robot-nav-err-pc {
  padding: 10px 15px;
  background: #f1f2f5;
  color: #222;
  font-size: 14px;
  border-radius: 2px 6px 6px 6px;
}
.robot-nav-err {
  padding: 10px 15px;
  background: #fff;
  color: #a1abc2;
  font-size: 12px;
  border-radius: 2px 6px 6px 6px;
}
.robot-nav-wrapper {
  &.pc.pc-not-frame {
    .robot-nav-err-pc {
      padding: 12px;
      font-size: 15px;
      line-height: 21px;
    }
  }
}
</style>
